import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Responses } from 'src/app/shared/interfaces/responses';
import { Rol } from 'src/app/shared/interfaces/rol';

@Injectable({
  providedIn: 'root'
})
export class RolesPermissionsService {
  private urlBase = environment.urlBase;
  constructor(
    private http: HttpClient,
  ) { }

  // Obtiene todos los permisos del usuario
  getPermissionsByUser(IdUsuario: number,IdRol: number): Observable<Responses>{
     return this.http.post<Responses>(`${this.urlBase}rolesPermissions/getPermissionsByUser`, {IdUsuario, IdRol});
  }

}
